export const LARGEST_THUMBNAIL_FONT_SIZE = "2rem";

export const THUMBNAIL_WIDTH_FONT_SIZE_MAPPING: [number, string][] = [
  [150, "0.9em"],
  [200, "1rem"],
  [300, "1.2rem"],
  [500, "1.2rem"],
  [600, "1.3rem"],
  [700, "1.4rem"],
  [800, "1.5rem"],
  [900, "1.6rem"],
  [1000, "1.7rem"],
  [1100, "1.8rem"],
  [1200, "1.9rem"],
];
